import { abbrNumber } from 'utils/chart';
import BaseChart from '../baseChart';

// type Props = {
//   /** An additional class. */
//   className?: string,
//   /* Numerator Value */
//   numerator: number,
//   /* Denominator Value */
//   denominator: number,
//   /* Set additional options for progress chart. */
//   options: {},
//   /* Theme of the progress chart. */
//   theme: string,
// };

export default function Progress(props) {
  const { className, numerator, denominator, options, theme, ...otherProps } = props;
  const fraction = numerator / denominator;
  const maxValue = 100;

  const defaultOptions = {
    chart: {
      height: 70,
    },
    tooltip: false,
    legend: false,
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
      min: 0,
      max: maxValue,
    },
  };

  const data = [
    {
      data: [maxValue],
      grouping: false,
      animation: false,
      enableMouseTracking: false,
      showInLegend: false,
      color: '#a3d7ff',
      pointWidth: 25,
      borderWidth: 0,
      dataLabels: {
        className: 'highlight',
        format: `${abbrNumber(numerator)} / ${abbrNumber(denominator)}`,
        enabled: true,
        align: 'right',
        style: {
          color: '#333',
          textOutline: false,
        },
      },
    },
    {
      enableMouseTracking: false,
      data: [Math.floor(fraction * maxValue)],
      color: '#717171',
      borderWidth: 0,
      pointWidth: 25,
      animation: {
        duration: 250,
      },
      dataLabels: {
        enabled: true,
        inside: true,
        align: 'left',
        format: '{point.y}%',
        style: {
          color: '#fff',
          textOutline: false,
        },
      },
    },
  ];

  return (
    <BaseChart
      className={className}
      chartType="bar"
      data={data}
      defaultOptions={defaultOptions}
      options={options}
      theme={theme}
      {...otherProps}
    />
  );
}
